module.exports = __webpack_public_path__ + "img/no-photo.fbdcd644.svg";